export const UserAccountEN = {
   "userAccount":{
       "columns":{
           "id":"ID",
           "screenName":"Screen Name",
           "fullName":"Full Name",
           "creatorName":"Creator Name",
           "createDate":"Create Date"
       },
       timekeeping: {
           title : "Timekeeping",
           leaveNoReason: "Leave No Reason",
           dayOf: "Day off",
           day: {
               mon: "Mon",
               tue: "Tue",
               wed: "Wed",
               thu: "Thu",
               fri: "Fri",
               sat: "Sat",
               sun: "Sun"
           }
       }
   }
}